import { useEffect, useState } from "react";

// Event starts 17 November 2026 · 09:00 Manila time (UTC+8)
const TARGET_MS = Date.UTC(2026, 10, 17, 1, 0, 0); // 09:00 PHT == 01:00 UTC

function diffParts(ms) {
  if (ms <= 0) return { d: 0, h: 0, m: 0, done: true };
  const d = Math.floor(ms / 86_400_000);
  const h = Math.floor((ms % 86_400_000) / 3_600_000);
  const m = Math.floor((ms % 3_600_000) / 60_000);
  return { d, h, m, done: false };
}

function Cell({ value, label }) {
  const v = String(value).padStart(2, "0");
  return (
    <div className="flex items-baseline gap-2">
      <span className="font-display text-2xl sm:text-3xl font-bold text-white tabular-nums drop-shadow-[0_2px_10px_rgba(0,0,0,0.6)]">
        {v}
      </span>
      <span className="mono text-[10px] uppercase tracking-[0.22em] text-cyan-200/80">
        {label}
      </span>
    </div>
  );
}

export default function Countdown() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 30_000); // update every 30s
    return () => clearInterval(id);
  }, []);

  const { d, h, m, done } = diffParts(TARGET_MS - now);

  return (
    <div
      data-testid="hero-countdown"
      className="inline-flex flex-wrap items-center gap-x-6 gap-y-3 rounded-full border border-cyan-500/40 bg-[#030712]/70 backdrop-blur px-5 py-3"
    >
      <div className="flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 animate-pulse" />
        <span className="mono text-[10px] uppercase tracking-[0.24em] text-cyan-300">
          {done ? "Live in Manila" : "Countdown to Manila"}
        </span>
      </div>
      {!done && (
        <>
          <Cell value={d} label="Days" />
          <span className="text-cyan-500/50">·</span>
          <Cell value={h} label="Hrs" />
          <span className="text-cyan-500/50">·</span>
          <Cell value={m} label="Min" />
        </>
      )}
    </div>
  );
}
